<template>
  <b-row>
    <b-col
      cols="12"
      :md="form.all_user === '0' ? 12 : 6"
    >
      <b-overlay
        :show="isPending"
        rounded="sm"
      >
        <b-card>
          <validation-observer ref="simpleRules">
            <b-form @submit.prevent="validationForm">
              <b-row>
                <b-col
                  cols="12"
                  :md="form.all_user === '0' ? 6 : 12"
                >
                  <!-- Pilih User -->
                  <b-form-group
                    label="Tujuan"
                    label-for="v-all_user"
                    label-cols-md="4"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Tujuan"
                      rules="required"
                    >
                      <div class="demo-inline-spacing">
                        <b-form-radio
                          v-model="form.all_user"
                          class="mt-0"
                          name="all_user"
                          value="0"
                        >
                          Pilih User
                        </b-form-radio>
                        <b-form-radio
                          v-model="form.all_user"
                          class="mt-0"
                          name="all_user"
                          value="1"
                        >
                          Semua User
                        </b-form-radio>
                      </div>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- Image -->
                  <b-form-group
                    label="Gambar"
                    label-for="v-image_url"
                    label-cols-md="4"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Gambar"
                    >
                      <form-image
                        id="v-image_url"
                        v-model="form.image_url"
                        label="Pilih Foto"
                        :state="errors.length > 0 ? false : null"
                        with-endpoin
                        @finish="setPhotoFile"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- Judul -->
                  <b-form-group
                    label="Judul"
                    label-for="v-title"
                    label-cols-md="4"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Judul"
                      rules="required"
                    >
                      <b-form-input
                        id="v-title"
                        v-model="form.title"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- Deskripsi -->
                  <b-form-group
                    label="Deskripsi"
                    label-for="v-description"
                    label-cols-md="4"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="Deskripsi"
                      rules="required"
                    >
                      <b-form-textarea
                        id="v-description"
                        v-model="form.description"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- URL notifikasi -->
                  <b-form-group
                    label="URL notifikasi"
                    label-for="v-url"
                    label-cols-md="4"
                  >
                    <validation-provider
                      #default="{ errors }"
                      name="URL"
                      rules="required"
                    >
                      <b-form-input
                        id="v-url"
                        v-model="form.url"
                        :state="errors.length > 0 ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-form-group>

                  <!-- Button -->
                  <div class="d-flex justify-content-end mt-3">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      :disabled="isSubmitting"
                    >
                      <b-spinner
                        v-if="isSubmitting"
                        small
                      />
                      {{ isSubmitting ? "Mengirim" : "Kirim" }}
                    </b-button>
                  </div>
                </b-col>

                <b-col
                  v-if="form.all_user === '0'"
                  cols="12"
                  md="1"
                />

                <b-col
                  v-if="form.all_user === '0'"
                  cols="12"
                  md="5"
                >
                  <!-- Guard Nama -->
                  <b-form-group
                    label="Cari User tujuan notifikasi"
                  >
                    <v-select
                      v-model="selected"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="name"
                      :options="users.data"
                      :selectable="(option) => option.name !== findDisable(option.name)"
                      @close="$store.commit('user/RESET_USER_LIST')"
                      @search="onSearchUsers"
                      @input="onSelectUser"
                    />
                  </b-form-group>

                  <hr>

                  <div v-if="usersSelected.length">
                    <b-list-group
                      flush
                    >
                      <b-list-group-item
                        v-for="(item, index) in usersSelected"
                        :key="`list-user-selected-${index}`"
                        class="d-flex justify-content-between align-items-center"
                      >
                        <span>
                          <b-media vertical-align="center">
                            <template #aside>
                              <b-avatar
                                :src="`${item.photo}?tr=w-50,h-50`"
                                :text="item.name.charAt(0)"
                                variant="light-primary"
                              />
                            </template>
                            <span class="font-weight-bold d-block">
                              {{ item.name }}
                            </span>
                            <small class="text-muted">{{ item.email }}</small>
                          </b-media>
                        </span>
                        <b-button
                          v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                          variant="flat-danger"
                          class="btn-icon"
                          @click="deleteUsers(index)"
                        >
                          <feather-icon icon="TrashIcon" />
                        </b-button>
                      </b-list-group-item>
                    </b-list-group>
                  </div>

                  <div
                    v-else
                    class="text-center"
                  >
                    Belum ada user ditambahkan
                  </div>
                </b-col>
              </b-row>
            </b-form>
          </validation-observer>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import vSelect from 'vue-select'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BForm,
  BButton,
  BSpinner,
  BOverlay,
  BFormRadio,
  BMedia,
  BListGroup,
  BListGroupItem,
  BAvatar,
} from 'bootstrap-vue'

import Ripple from 'vue-ripple-directive'

import FormImage from '@/layouts/components/custom/FormImage.vue'

// Vee Validate
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BForm,
    BButton,
    BOverlay,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
    BFormRadio,
    BMedia,
    BListGroup,
    BListGroupItem,
    BAvatar,
    vSelect,
    FormImage,
  },
  directives: {
    Ripple,
  },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        title: '',
        description: '',
        url: '',
        image_url: '',
        all_user: '0',
      },
      required,
      isPending: false,
      isSubmitting: false,
      usersSelected: [],
      selected: '',
    }
  },
  computed: {
    ...mapState('user', ['users']),
  },
  async created() {
    this.isPending = true
    this.isPending = false
  },
  methods: {
    ...mapActions('user', ['getUserList']),
    ...mapActions('notification', ['sendNotif']),
    async setPhotoFile(data) {
      const datas = await JSON.parse(JSON.stringify(data))
      if (data) {
        this.form.image_url = `${datas.image_url}?tr=w-300,h-300`
      }
    },
    resetForm() {
      this.form = {
        title: '',
        description: '',
        url: '',
        all_user: '0',
      }
      this.usersSelected = []
      this.selected = ''
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.form.all_user === '0' && !this.usersSelected.length) {
            this.$store.commit('response/SET_ERROR', {
              message: 'Anda belum memilih tujuan user.',
            }, { root: true })
            return
          }
          this.handleSubmit()
        }
      })
    },
    async handleSubmit() {
      this.isSubmitting = true

      const users = this.usersSelected.map(el => el.id)
      await this.sendNotif({ data: this.form, users })
      await this.resetForm()
      this.$refs.simpleRules.reset()

      this.isSubmitting = false
    },
    // Edit State Only
    findDisable(name) {
      const data = this.usersSelected.find(el => el.name === name)
      if (data) {
        return data.name
      }
      return ''
    },
    async onSelectUser(data) {
      this.usersSelected.push(data)
    },
    deleteUsers(index) {
      this.usersSelected.splice(index, 1)
    },
    async onSearchUsers(keyword, loading) {
      if (keyword.length) {
        loading(true)
        this.searchUsers(loading, keyword, this)
      }
    },
    searchUsers: _.debounce((loading, search, that) => {
      that.getUserList({ keyword: search, type: 'buyer', haveToken: true }).finally(() => {
        loading(false)
      })
    }, 500),
  },
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>
